import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const opsVisibilityApi = {
    getOrderSources: async () => {
        const url = `api/operations/visibility/v1/orderSources`;
        return mmFetchWithResponse(url);
    },
    /**
     * Fetch detailed OOB manifest data (JSON) for a specific route
     * Returns structured data to be converted to CSV client-side
     */
    getOutOfBoxManifestDetailed: async ({ expectedPackDate, lineHaulId, route }) => {
        const url = `api/operations/visibility/v1/outOfBoxManifestByRoute?lineHaulId=${lineHaulId}&expectedPackDate=${encodeURIComponent(
            expectedPackDate,
        )}&route=${encodeURIComponent(route)}`;
        return mmFetchWithResponse(url);
    },
    getShipmentStatusFlowControl: async (facilityID) => {
        const url = `api/operations/visibility/v1/flowControl?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getShipmentStatusFlowControlWithFilters: async (facilityID, startDate, endDate, sendParams) => {
        const url = `api/operations/visibility/v1/flowControlFiltered?facilityID=${facilityID}&startDate=${startDate}&endDate=${endDate}`;

        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    getOutOfBoxManifest: async (lineHaulId, packDate) => {
        const url = `api/operations/visibility/v1/outOfBoxManifest?lineHaulId=${lineHaulId}&expectedPackDate=${packDate}`;
        return mmFetchWithResponse(url);
    },
    /**
     * Download detailed OOB manifest CSV for a specific route (server returns CSV)
     */
    downloadOutOfBoxManifestByRouteCsv: async ({ expectedPackDate, lineHaulId, route }) => {
        const url = `api/operations/visibility/v1/outOfBoxManifestByRoute?lineHaulId=${lineHaulId}&expectedPackDate=${encodeURIComponent(
            expectedPackDate,
        )}&route=${encodeURIComponent(route)}`;

        const filename = `OOB_Detailed_${lineHaulId}_${route}_${expectedPackDate}.csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return { status: true };
                }

                const objectUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = objectUrl;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (
                        typeof window !== 'undefined' &&
                        window.URL &&
                        typeof window.URL.revokeObjectURL === 'function'
                    ) {
                        window.URL.revokeObjectURL(objectUrl);
                    }
                }, 200);
                return { status: true };
            }

            let msg = 'Failed to download CSV';
            try {
                const decoded = await res.json();
                msg = decoded.msg || msg;
            } catch (e) {}
            return { status: false, msg };
        } catch (e) {
            return { status: false, msg: e.toString() };
        }
    },
    getOutOfBoxAvailability: async () => {
        const url = `api/opsvisibility/v1/outOfBoxAvailability`;
        return mmFetchWithResponse(url);
    },
    uploadOutOfBoxAvailability: async (formData) => {
        const url = `api/opsvisibility/v1/outOfBoxAvailabilityBulk`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    confirmOutOfBoxAvailabilityUpload: async (key) => {
        const url = `api/opsvisibility/v1/outOfBoxAvailabilityBulk`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
    },
    /**
     * Fetch frozen manifest data (JSON) for a line haul
     */
    getFrozenManifest: async (lineHaulId, packDate) => {
        const url = `api/operations/visibility/v1/frozenManifest?lineHaulId=${lineHaulId}&expectedPackDate=${packDate}`;
        return mmFetchWithResponse(url);
    },
    /**
     * Download detailed frozen manifest CSV for a specific route (server returns CSV)
     */
    downloadFrozenManifestByRouteCsv: async ({ expectedPackDate, lineHaulId, route }) => {
        const url = `api/operations/visibility/v1/frozenManifestByRoute?lineHaulId=${lineHaulId}&expectedPackDate=${encodeURIComponent(
            expectedPackDate,
        )}&route=${encodeURIComponent(route)}`;

        const filename = `Frozen_Detailed_${lineHaulId}_${route}_${expectedPackDate}.csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return { status: true };
                }

                const objectUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = objectUrl;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (
                        typeof window !== 'undefined' &&
                        window.URL &&
                        typeof window.URL.revokeObjectURL === 'function'
                    ) {
                        window.URL.revokeObjectURL(objectUrl);
                    }
                }, 200);
                return { status: true };
            }

            let msg = 'Failed to download CSV';
            try {
                const decoded = await res.json();
                msg = decoded.msg || msg;
            } catch (e) {}
            return { status: false, msg };
        } catch (e) {
            return { status: false, msg: e.toString() };
        }
    },
};

export { opsVisibilityApi };
